import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  signature?: string;
}

export function CuratorBubble({ children, signature }: Props) {
  return (
    <div className="flex gap-[14px]">
      <div
        className="relative h-[42px] w-[42px] flex-none overflow-hidden rounded-full"
        style={{
          background: "linear-gradient(180deg, #1a1030, #0b0614)",
        }}
      >
        <span
          className="absolute h-[10px] w-[10px] rounded-full"
          style={{
            background: "#c8a8ff",
            left: "24%",
            top: "20%",
            filter: "blur(1px)",
            opacity: 0.8,
          }}
        />
      </div>
      <div className="font-display italic font-light text-[16px] leading-[1.32] text-ink/85">
        {children}
        {signature && (
          <small className="mt-[6px] block not-italic font-sans editorial-meta text-ink/55">
            — {signature}
          </small>
        )}
      </div>
    </div>
  );
}
